import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Star } from 'lucide-react';

const FacultyEvaluationForm = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container-custom">
        <div className="mb-8">
          <button
            onClick={() => navigate('/forms')}
            className="flex items-center text-blue-800 hover:text-red-900 mb-4"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Forms
          </button>
          
          <div className="text-center">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Star className="w-8 h-8 text-blue-800" />
            </div>
            <h1 className="text-3xl font-bold text-gray-800 mb-2">
              Faculty Evaluation Form
            </h1>
            <p className="text-gray-600 max-w-2xl mx-auto">
              This form will be available soon for faculty to evaluate guidance services.
            </p>
          </div>
        </div>

        <div className="form-container text-center">
          <p className="text-gray-600 mb-6">
            This form is currently under development and will be available in the next update.
          </p>
          <button
            onClick={() => navigate('/forms')}
            className="btn-primary"
          >
            Return to Forms
          </button>
        </div>
      </div>
    </div>
  );
};

export default FacultyEvaluationForm;